import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { userSchema } from "../user";

export const aiUsageSchema = z.object({
  id: z.string(),
  callId: z.string(),
  userId: z.string().nullable(),
  feature: z.string(),
  model: z.string(),
  tokensIn: z.number(),
  tokensOut: z.number(),
  costUsd: z.number(),
  costFcfa: z.number().nullable(),
  pointsEstimated: z.number().nullable(),
  pointsCharged: z.number().nullable(),
  status: z.enum(["PENDING", "COMPLETED", "FAILED", "REFUNDED"]),
  error: z.string().nullable(),
  durationMs: z.number().nullable(),
  user: userSchema.optional(),
  createdAt: z.coerce.date(),
});

export class AiUsageDto extends createZodDto(aiUsageSchema) {}
